import { render, staticRenderFns } from "./Gazettal.vue?vue&type=template&id=b0190a54&"
import script from "./Gazettal.vue?vue&type=script&lang=ts&"
export * from "./Gazettal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports